import React, { createElement, useState, useEffect, useRef } from 'react'
import { useCallback } from 'react'
import { Box } from '@chakra-ui/react'
import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import DatePicker from 'react-datepicker'
import { ControllerRenderProps, FieldValues, UseFormSetValue } from 'react-hook-form'
import DateRangeInputWithMask, { DateRangeValues } from './components/DateRangeInputWithMask'
dayjs.extend(advancedFormat)

interface ICustomDatePickerProps {
  name: string
  field: ControllerRenderProps<FieldValues, any> // * INFO: use "any" type here for dynamic data
  dateFormat: string
  inputMask: string[]
  inputFormat: string
  inputPlaceholder: string
  setValue: UseFormSetValue<FieldValues>
  height?: string
}

export const CustomDateRangePickerWithMask = (props: ICustomDatePickerProps) => {
  const { field, name, inputMask, inputFormat, inputPlaceholder, dateFormat, setValue, height } = props
  const { onChange, value: dateRangeValues } = field
  const [startDate, setStartDate] = useState<Date | null>(null)
  const [endDate, setEndDate] = useState<Date | null>(null)
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const pickerRef = useRef<HTMLDivElement>(null)

  const handleClickOutSide = useCallback(
    (event) => {
      if (!pickerRef.current?.contains(event?.target) && isOpen) {
        setIsOpen(false)
      }
    },
    [isOpen, pickerRef]
  )

  function handleOnChange(currentDateRangeValues: DateRangeValues): void {
    onChange(currentDateRangeValues)
  }

  useEffect(() => {
    if (dateRangeValues) {
      const currentStartDate: Date | null = dateRangeValues[0]
      const currentEndDate: Date | null = dateRangeValues[1]

      setStartDate(currentStartDate)
      setEndDate(currentEndDate)
      if (currentStartDate && currentEndDate) {
        setIsOpen(false)
      }
    }
  }, [dateRangeValues])

  useEffect(() => {
    window.addEventListener('click', handleClickOutSide, true)
  }, [handleClickOutSide])

  return (
    <Box ref={pickerRef}>
      <DatePicker
        selected={startDate}
        name={name}
        open={isOpen}
        onChange={handleOnChange}
        startDate={startDate}
        endDate={endDate}
        dateFormat={dateFormat}
        customInput={createElement(({ value, onClick }) => {
          return (
            <DateRangeInputWithMask
              name={name}
              value={value}
              format={inputFormat}
              mask={inputMask}
              placeholder={inputPlaceholder}
              height={height}
              setIsOpenCalendar={setIsOpen}
              setValue={setValue}
              onClick={onClick}
            />
          )
        })}
        selectsRange
        onInputClick={() => {
          setIsOpen(true)
        }}
      />
    </Box>
  )
}
export default CustomDateRangePickerWithMask
